import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Router from '../../routers';
import { isLogged } from '../../services/authorization-service';
import { useToggleNavBar } from '../../libraries/contexts';
import { content as styles } from './css';

const Content = props => {
  const {
    classes: {
      content,
      toolbar,
      drawerOpen,
      drawerClose,
      drawerSecondaryOpen,
      drawerBothOpen,
      logoutBar
    }
  } = props;
  const toggleManager = useToggleNavBar();

  const { main, secondary } =
    toggleManager.length > 0 ? toggleManager[0] : { main: false, secondary: false };
  const isOut = !isLogged();
  return (
    <main
      className={classNames(content, {
        [drawerOpen]: main && !secondary,
        [drawerClose]: !main && !secondary,
        [drawerSecondaryOpen]: !main && secondary,
        [drawerBothOpen]: main && secondary,
        [logoutBar]: isOut
      })}
    >
      <div className={toolbar} />
      <Switch>
        <Router />
      </Switch>
    </main>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Content);
